export default class AnimationService {
    constructor() {
        //Launch parallax

        AnimationService.initRellax().then()
        AnimationService.scrollReveal()
        AnimationService.removeHeaderAnimatedClass()
    }

    static async initRellax() {
        const {default: Rellax} = await import('rellax')
        new Rellax('.parallaxe', {
            center: true,
        })
    }

    static removeHeaderAnimatedClass() {
        const $body = $('body')

        if ($body.hasClass('hp-header-animated')) {
            setTimeout(() => {
                $body.removeClass('hp-header-animated')
            }, 2500)
        }
    }

    static scrollReveal() {
        const ratio = 0.25
        const options = {
            root: null,
            rootMargin: '-50px',
            threshold: ratio,
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach((e) => {
                if (e.intersectionRatio >= ratio) {
                    $(e.target).addClass('is-loaded')
                    observer.unobserve(e.target)
                }
            })
        }

        const observer = new IntersectionObserver(handleIntersect, options)

        document.querySelectorAll('[data-cx-animation]').forEach((el) => {
            observer.observe(el)
        })
    }
}
